<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Chi tiết sản phẩm</h2>
        <div class="actions">
          <button v-if="!isEdit" @click="isEdit = true">✏️ Sửa</button>
          <button v-if="isEdit" @click="handleUpdate">💾 Lưu</button>
          <button class="btn-close" @click="$emit('close')">✖</button>
        </div>
      </div>

      <!-- TABS -->
      <div class="tabs">
        <button :class="{ active: tab === 'general' }" @click="tab = 'general'">
          Thông tin
        </button>
        <button :class="{ active: tab === 'price' }" @click="tab = 'price'">
          Giá & Kho
        </button>
        <button
          :class="{ active: tab === 'advanced' }"
          @click="tab = 'advanced'"
        >
          Nâng cao
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <!-- TAB 1 -->
        <div v-if="tab === 'general'" class="grid">
          <div class="form-group">
            <label for="">Tên hàng</label>
            <input
              v-model="form.ten_hang"
              :disabled="!isEdit"
              placeholder="Tên hàng"
            />
          </div>
          <div class="form-group">
            <label for="">Mã hàng</label>
            <input
              v-model="form.ma_hang"
              :disabled="!isEdit"
              :readonly="isEdit"
            />
          </div>
          <div class="form-group">
            <label for="">Nhà cung cấp</label>
            <select v-model="form.supplier_id" :disabled="!isEdit">
              <option value="null">-- Chọn nhà cung cấp --</option>
              <option
                v-for="supplier in suppliers"
                :key="supplier.id"
                :value="supplier.id"
              >
                {{ supplier.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Thương hiệu</label>
            <input v-model="form.thuong_hieu" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Mô tả</label>
            <textarea v-model="form.mo_ta" :disabled="!isEdit"></textarea>
          </div>

          <!-- ảnh -->
          <div class="form-group">
            <label for="">Hình ảnh</label>
            <div>
              <img
                v-if="preview || form.hinh_anh"
                :src="preview || form.hinh_anh"
                class="preview"
              />
              <input v-if="isEdit" type="file" @change="handleImage" />
            </div>
          </div>
        </div>

        <!-- TAB 2 -->
        <div v-if="tab === 'price'" class="grid">
          <div class="form-group">
            <label for=""> Giá bán</label>
            <input v-model="giaBanDisplay" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Giá vốn</label>
            <input v-model="giaVonDisplay" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Tồn kho</label>
            <input type="number" v-model="form.ton_kho" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Tồn nhỏ nhất</label>
            <input
              type="number"
              v-model="form.ton_nho_nhat"
              :disabled="!isEdit"
            />
          </div>
          <div class="form-group">
            <label for="">Tồn lớn nhất</label>
            <input
              type="number"
              v-model="form.ton_lon_nhat"
              :disabled="!isEdit"
            />
          </div>
          <div class="form-group">
            <label for="">Đơn vị tính</label>
            <input type="number" v-model="form.dvt" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Mã ĐVT cơ bản</label>
            <input
              type="number"
              v-model="form.ma_dvt_co_ban"
              :disabled="!isEdit"
            />
          </div>
          <div class="form-group">
            <label for="">Quy đổi</label>
            <input type="number" v-model="form.quy_doi" :disabled="!isEdit" />
          </div>
        </div>

        <!-- TAB 3 -->
        <div v-if="tab === 'advanced'" class="grid">
          <div class="form-group">
            <label for="">Thuộc tính</label>
            <input v-model="form.thuoc_tinh" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Mã HH liên quan</label>
            <input v-model="form.ma_hh_lien_quan" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Trọng lượng</label>
            <input v-model="form.trong_luong" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Serial Imei</label>
            <input v-model="form.serial_imei" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Vị trí</label>
            <input v-model="form.vi_tri" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Bảo hành</label>
            <input v-model="form.bao_hanh" :disabled="!isEdit" />
          </div>
          <div class="form-group">
            <label for="">Bảo trì định kỳ</label>
            <input v-model="form.bao_tri_dinh_ky" :disabled="!isEdit" />
          </div>

          <label
            ><input type="checkbox" v-model="form.su_dung_imei" /> Sử dụng
            IMEI</label
          >
          <label
            ><input type="checkbox" v-model="form.dang_kinh_doanh" /> Đang kinh
            doanh</label
          >
          <label
            ><input type="checkbox" v-model="form.duoc_ban_truc_tiep" /> Bán
            trực tiếp</label
          >
        </div>
      </div>
      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn-save" :hidden="!isEdit" @click="handleUpdate">
          Lưu
        </button>
        <button @click="$emit('close')">Đóng</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { productApi, supplierApi } from "@/services/api";
import { formatCurrency, getAvatarUrl, parseCurrency } from "@/utils/helpers";
import { ref, reactive, computed, watch, toRefs, onMounted } from "vue";

const toast = useToast();
const props = defineProps({
  product: Object,
});
const { product } = toRefs(props);
const emit = defineEmits(['save']);
const isEdit = ref(false);
const tab = ref("general");
const suppliers = ref([]);
const form = reactive({});
const originalData = ref({});

watch(
  () => product.value,
  (val) => {
    Object.assign(form, val);
    originalData.value = JSON.parse(JSON.stringify(val));
  },
  { immediate: true , deep: true},
);

const giaBanDisplay = computed({
  get: () => formatCurrency(form.gia_ban),
  set: (val) => (form.gia_ban = parseCurrency(val)),
});

const giaVonDisplay = computed({
  get: () => formatCurrency(form.gia_von),
  set: (val) => (form.gia_von = parseCurrency(val)),
});

const preview = ref(getAvatarUrl(form.hinh_anh));

const handleImage = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  form.hinh_anh = file;
  preview.value = URL.createObjectURL(file);
};

// update
const handleUpdate = async () => {
  let hasChanged = false;
  const formData = new FormData();

  Object.keys(form).forEach((key) => {
    if (form[key] != originalData.value[key]) {
      let value = form[key];
      if (typeof value === "boolean") value = value ? 1 : 0;
      if (value === null || value === undefined) value = "";
      formData.append(key, form[key]);
      hasChanged = true;
    }
  });
  if (!hasChanged) {
    toast.info("Bạn chưa thay đổi thông tin nào");
    return;
  }
  formData.append("_method", "PUT");

  try {
    const productID = product.value.id;
    await productApi.updateProduct(productID, formData);
    toast.success("Cập nhật thành công");
    isEdit.value = false;
    originalData.value = { ...form };
    emit("save");
  } catch (err) {
    const errorMessage = err.response.data.error || "Lỗi cập nhật sản phẩm";
    toast.error(errorMessage);
    console.error(err);
  }
};

const fetchSuppliers = async () => {
  try {
    const response = await supplierApi.getSuppliers();
    suppliers.value = response.data.data.data || response.data;
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Lỗi khi tải danh sách nhà cung cấp";
    toast.error(errorMessage);
    console.error(err);
  }
};
onMounted(() => {
  fetchSuppliers();
});
</script>
<style scoped>
.modal-header button {
  padding: 10px;
}
</style>
